import { useState, useEffect, useRef, useLayoutEffect, } from 'react';

const CollapsibleContainer = ({children, isOpen = false, transitionSpeed = '0.3s' }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const [containerHeight, setContainerHeight] = useState('0px');
  const [isFullyOpen, setIsFullyOpen] = useState(false); // using this to allow overflow when fully open
  const [isFirstLayout, setIsFirstLayout] = useState(true); // using this to prevent animating open if it is open intially

  useLayoutEffect(() => {
    if(!containerRef.current) return;

    setContainerHeight(isOpen === true ? `${containerRef.current.scrollHeight}px` : '0px');
    if(!isOpen) {
      setIsFullyOpen(false);
      setIsFirstLayout(false);
    } else if(containerHeight === containerRef.current.scrollHeight) {
      setIsFirstLayout(false);
    }
  }, [isOpen, containerHeight]);

  useEffect(() => {
    if (!contentRef.current || !isOpen) return;

    const observer = new ResizeObserver(() => {
      setContainerHeight(`${contentRef.current.scrollHeight}px`);
    });

    observer.observe(contentRef.current);

    return () => observer.disconnect();
  }, [isOpen]);

  const handleTransitionEnd = () => {
    if(!containerRef.current) return;

    setIsFullyOpen(isOpen);
  };

  return (
    <div 
      ref={containerRef}
      onTransitionEnd={handleTransitionEnd}
      className={`w-full ${!isFullyOpen ? 'overflow-hidden' : ''}`}
      style={{
        maxHeight: containerHeight,
        transition: `max-height ${isFirstLayout ? '0s' : transitionSpeed} ease`,
      }}
    >
      <div ref={contentRef} className={`w-full left-0 top-0`}>
        {children}
      </div>
    </div>
  );
};

export default CollapsibleContainer;
